import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { BorderButton, QuestionnaireHeader, ScreenContainer, Text } from "../components"
import { QuestionnaireStore } from "../stores/QuestionnaireStore"

export const QuestionnairePage = observer(() => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [store] = useState(() => new QuestionnaireStore())

	useEffect(() => {
		store.load()
	}, [store])

	return (
		<>
			{store.questionnaire && (
				<ScreenContainer>
					<div className="flex min-h-full flex-col pb-[120px]">
						<QuestionnaireHeader to={"placeholder"} />
						<div className="mt-[54px] flex items-center justify-center">
							<Text style="text-[50px] font-extrabold uppercase leading-[44px]">{store.questionnaire.title}</Text>
						</div>
						<div className="mt-[54px] flex items-center justify-center">
							<Text>{store.questionnaire.description}</Text>
						</div>
						<div className="absolute bottom-[45px] w-full">
							<BorderButton text={t("questionnaire.start_button")} onClick={() => navigate("")} />
						</div>
					</div>
				</ScreenContainer>
			)}
		</>
	)
})
